module.exports = __webpack_public_path__ + "flag_kurdistan.svg?52e437a6854cf6e8dca6f65f69ad85ef";


//////////////////
// WEBPACK FOOTER
// ./assets/flags/flag_kurdistan.svg
// module id = 540
// module chunks = 0